import { request } from './index';
import constants from '../constants';

/**
 * Retrieves the configuration by type.
 *
 * @param {string} type - The type of configuration to retrieve.
 * @returns {Promise<any>} A promise that resolves with the retrieved configuration data.
 */
const getConfigByType = (type) => {
    return new Promise((resolve, reject) => {
        return request({
            method: "get",
            url: `${constants.API_ENDPOINT}/systemConfig/${type}`
        })
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error.result)
            })
    })
}

/**
 * Updates the configuration by type.
 *
 * @param {string} type - The type of configuration to update.
 * @param {object} payload - The payload containing the updated configuration data.
 * @returns {Promise<object>} A promise that resolves to the updated configuration data.
 */
const updateConfigByType = (type, payload) => {
    return new Promise((resolve, reject) => {
        return request({
            method: "put",
            url: `${constants.API_ENDPOINT}/systemConfig/${type}`,
            data: payload
        })
            .then(res => {
                resolve(res.data)
            })
            .catch((error) => {
                reject(error.result)
            })
    })
}


/**
 * Exports the login history for users within a specified date range.
 *
 * @param {string} fromDate - The start date of the range (format: YYYY-MM-DD).
 * @param {string} toDate - The end date of the range (format: YYYY-MM-DD).
 * @returns {Promise<Blob>} A promise that resolves with the exported login history as a Blob.
 */
const exportLoginHistory = (fromDate, toDate) => {
    ///user/export/loginStatus?from=2025-07-30&to=2025-07-31

    return new Promise((resolve, reject) => {
        return request({
            method: "get",
            url: `${constants.API_ENDPOINT}/user/export/loginStatus?from=${fromDate}&to=${toDate}`,
        })
            .then(res => {
                resolve(res)
            })
            .catch((error) => {
                reject(error.result)
            })
    })

}

export {
    getConfigByType,
    updateConfigByType,
    exportLoginHistory
}
